import { AppContext } from '../global/models/app-context-model';
import { BasePageModel } from '../global/models/ecd-page-models';
import { BaseEcdEpiApiState } from '../global/models/epi-config-state-model';
import { DefaultEcdClergySettingsState, DefaultEcdMailSettingsState, DefaultEcdParishSettingsState, DefaultSiteSettingsState, EcdContentPropsState, EcdEpiProps } from '../global/models/epi-model';
import { BaseAppState } from '../global/models/redux-state';

export interface EcdEpiApiState extends BaseEcdEpiApiState<EcdEpiProps> {	
	pageData?: EcdContentPropsState<BasePageModel>;	
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DefaultEcdEpiProps: EcdEpiProps = {
	// base
	pageTitle: '',
	apiResponseMessages: [],
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DefaultEcdEpiApiState: EcdEpiApiState = {
	contentState: {
		contentLoaded: false,
		epiContent: DefaultEcdEpiProps,
	},
	labelSettingState: {
		contentLoaded: false,
		epiContent: null,
	},
	siteSettingsState: DefaultSiteSettingsState,
	pageData: {
		contentLoaded: false,
		epiContent: null,
	},
	clergySettingsState: DefaultEcdClergySettingsState,
	parishSettingsState: DefaultEcdParishSettingsState,
	mailSettingsState: DefaultEcdMailSettingsState,
};

export interface EcdStates extends BaseAppState {
	epiProps: EcdEpiApiState,	
	appContext: AppContext;
}